var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from '../framework/Timeouts';
function parseIndex(n, args, indices, max) {
    var _a, _b, _c;
    const index = parseInt((_a = args[n]) !== null && _a !== void 0 ? _a : '3042597760', 10);
    if (Number.isNaN(index)) {
        const pos = (_c = (_b = indices === null || indices === void 0 ? void 0 : indices[n]) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : '?';
        return new ErrorMessage(`-ERR Parse error at ${pos}: could not parse value`);
    }
    if (index < 1 || index > max) {
        let msg = `-ERR INVALID_PARAMETER Index out of range:channelIndex `;
        msg += `min:1 max:${max} received:${index}`;
        return new ErrorMessage(msg);
    }
    return index;
}
function tokenize(str) {
    var _a, _b, _c, _d;
    const regExp = /(\s*)?(?:"([^"]*)"|([^"]\S*))/g;
    const tokens = [];
    const indices = [];
    let match = regExp.exec(str);
    while (match) {
        if (match[2] !== undefined) {
            tokens.push(match[2]);
            const index = match.index + ((_b = (_a = match[1]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + 1;
            indices.push([index, index + match[2].length]);
        }
        else {
            tokens.push(match[3]);
            const index = match.index + ((_d = (_c = match[1]) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0);
            indices.push([index, index + match[3].length]);
        }
        match = regExp.exec(str);
    }
    return [tokens, indices];
}
class ErrorMessage {
    constructor(message) {
        this.message = message;
    }
}
class AttributeBase {
    constructor(def) {
        var _a, _b;
        this.subscriptions = [];
        this.values = [];
        this.defaultValue = def.defaultValue;
        this.isReadOnly = (_a = def.isReadOnly) !== null && _a !== void 0 ? _a : false;
        this.name = def.name;
        this.numChannels = (_b = def.numChannels) !== null && _b !== void 0 ? _b : 0;
    }
    get(index) {
        var _a;
        return (_a = this.values[index !== null && index !== void 0 ? index : 0]) !== null && _a !== void 0 ? _a : this.defaultValue;
    }
    handleCommand(socket, args, indices) {
        var _a, _b, _c, _d, _e;
        const cmd = (_a = args[1]) !== null && _a !== void 0 ? _a : '';
        if (cmd === 'get') {
            this.handleGetCommand(socket, args, indices);
        }
        else if (cmd === 'set') {
            this.handleSetCommand(socket, args, indices);
        }
        else if (cmd === 'subscribe') {
            this.handleSubscribeCommand(socket, args, indices);
        }
        else if (cmd === 'unsubscribe') {
            this.handleUnsubscribeCommand(socket, args, indices);
        }
        else {
            const pos = (_e = (_c = (_b = indices === null || indices === void 0 ? void 0 : indices[1]) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : (_d = indices === null || indices === void 0 ? void 0 : indices[0]) === null || _d === void 0 ? void 0 : _d[1]) !== null && _e !== void 0 ? _e : '?';
            let msg = `-ERR Parse error at ${pos}: `;
            msg += `verb was not one of the commands supported by Services`;
            socket.send(msg);
        }
    }
    handleGetCommand(socket, args, indices) {
        var _a;
        let n = 3;
        let index = 0;
        if (this.numChannels > 0) {
            index = parseIndex(n, args, indices, this.numChannels);
            if (index instanceof ErrorMessage) {
                socket.send(index.message);
                return;
            }
            if (index === undefined)
                return;
            n++;
        }
        const value = this.formatValue((_a = this.values[index]) !== null && _a !== void 0 ? _a : this.defaultValue);
        socket.send(`+OK "value":${value}`);
    }
    handleSetCommand(socket, args, indices) {
        var _a, _b, _c, _d;
        let n = 3;
        let index = 0;
        if (this.numChannels > 0) {
            index = parseIndex(n, args, indices, this.numChannels);
            if (index instanceof ErrorMessage) {
                socket.send(index.message);
                return;
            }
            n++;
        }
        const valueStr = args[n];
        if (valueStr === undefined) {
            const pos = (_b = (_a = indices === null || indices === void 0 ? void 0 : indices[n - 1]) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : '?';
            const msg = `-ERR Parse error at ${pos}: not enough parameters specified`;
            socket.send(msg);
            return;
        }
        if (this.isReadOnly) {
            socket.send(`-ERR operation set not supported on attribute: version`);
            return;
        }
        const value = this.parseValue(valueStr);
        if (value instanceof ErrorMessage) {
            socket.send(value.message);
            return;
        }
        else if (value === undefined) {
            const pos = (_d = (_c = indices === null || indices === void 0 ? void 0 : indices[n]) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : '?';
            const msg = `-ERR Parse error at ${pos}: could not parse value`;
            socket.send(msg);
            return;
        }
        socket.send(`+OK`);
        this.set(socket, value, index);
    }
    handleSubscribeCommand(socket, args, indices) {
        var _a;
        let n = 3;
        let index = 0;
        if (this.numChannels > 0) {
            index = parseIndex(n, args, indices, this.numChannels);
            if (index instanceof ErrorMessage) {
                socket.send(index.message);
                return;
            }
            n++;
        }
        const name = (_a = args[n]) !== null && _a !== void 0 ? _a : '';
        const subscription = this.subscriptions.find(sub => sub.index === index && sub.name === name);
        if (subscription !== undefined) {
            socket.send(`-ERR ALREADY_SUBSCRIBED`);
            return;
        }
        this.subscriptions.push({ index, name });
        this.notify(socket, index, name);
        socket.send(`+OK`); // yes, tesira sends the notification before the OK
    }
    handleUnsubscribeCommand(socket, args, indices) {
        var _a;
        let n = 3;
        let index = 0;
        if (this.numChannels > 0) {
            index = parseIndex(n, args, indices, this.numChannels);
            if (index instanceof ErrorMessage) {
                socket.send(index.message);
                return;
            }
            n++;
        }
        const name = (_a = args[n]) !== null && _a !== void 0 ? _a : '';
        const subscriptionIndex = this.subscriptions.findIndex(sub => sub.index === index && sub.name === name);
        if (subscriptionIndex < 0) {
            socket.send(`-ERR NOT_SUBSCRIBED`);
            return;
        }
        this.subscriptions.splice(subscriptionIndex, 1);
        socket.send(`+OK`);
    }
    notify(socket, index, name) {
        var _a;
        const value = this.formatValue((_a = this.values[index]) !== null && _a !== void 0 ? _a : this.defaultValue);
        for (const subscription of this.subscriptions) {
            if (subscription.index === index &&
                (name === undefined || subscription.name === name)) {
                socket.send(`! "publishToken":"${subscription.name}" "value":${value}`);
            }
        }
    }
    set(socket, value, index) {
        var _a;
        index = index !== null && index !== void 0 ? index : 0;
        const changed = value !== ((_a = this.values[index]) !== null && _a !== void 0 ? _a : this.defaultValue);
        this.values[index] = value;
        if (changed)
            this.notify(socket, index);
    }
}
class BooleanAttribute extends AttributeBase {
    constructor(def) {
        var _a;
        super(Object.assign(Object.assign({}, def), { defaultValue: (_a = def.defaultValue) !== null && _a !== void 0 ? _a : false }));
    }
    formatValue(value) {
        return value ? 'true' : 'false';
    }
    parseValue(str) {
        if (str === 'true' || str === 'TRUE')
            return true;
        if (str === 'false' || str === 'FALSE')
            return false;
        const value = parseInt(str, 10);
        if (!Number.isNaN(value))
            return value !== 0;
        return undefined;
    }
}
class NumberAttribute extends AttributeBase {
    constructor(def) {
        var _a;
        super(Object.assign(Object.assign({}, def), { defaultValue: (_a = def.defaultValue) !== null && _a !== void 0 ? _a : 0 }));
        this.range = def.range;
    }
    formatValue(value) {
        return value.toFixed(6);
    }
    parseValue(str) {
        const value = parseFloat(str);
        if (Number.isNaN(value))
            return undefined;
        if (value < this.range.min || value > this.range.max) {
            return new ErrorMessage(`-ERR INVALID_PARAMETER`);
        }
        return value;
    }
}
class StringAttribute extends AttributeBase {
    constructor(def) {
        var _a;
        super(def);
        this.addQuotes = (_a = def.addQuotes) !== null && _a !== void 0 ? _a : true;
    }
    formatValue(value) {
        return this.addQuotes ? `"${value}"` : value;
    }
    parseValue(str) {
        return str;
    }
}
class Block {
    constructor(numChannels = 0) {
        this.numChannels = numChannels;
    }
    // args:
    // 0   1         2    3    4
    // Foo get       mute
    // Foo set       mute true
    // Foo get       mute 1
    // Foo set       mute 1    true
    // Foo subscribe mute 1    name 500
    // Foo subscribe mute name 500
    handleCommand(socket, args, indices) {
        var _a, _b, _c, _d, _e, _f;
        const cmd = (_a = args[1]) !== null && _a !== void 0 ? _a : '';
        const attr = (_b = args[2]) !== null && _b !== void 0 ? _b : '';
        if (cmd === 'get' && attr === 'numChannels' && this.numChannels > 0) {
            socket.send(`+OK "value":${this.numChannels}`);
            return;
        }
        const attribute = this.findAttribute(attr);
        if (attribute !== undefined) {
            attribute.handleCommand(socket, args, indices);
            return;
        }
        if (cmd === 'get' || cmd === 'set' || cmd === 'subscribe') {
            socket.send(`-ERR '${attr}' is not supported by ${this.className}::Attributes`);
            return;
        }
        const pos = (_f = (_d = (_c = indices === null || indices === void 0 ? void 0 : indices[2]) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : (_e = indices === null || indices === void 0 ? void 0 : indices[1]) === null || _e === void 0 ? void 0 : _e[1]) !== null && _f !== void 0 ? _f : '?';
        let msg = `-ERR Parse error at ${pos}: `;
        msg += `verb was not one of the commands supported by Services`;
        socket.send(msg);
    }
    findAttribute(name) {
        return this.attributes.find(attr => attr.name === name);
    }
}
class Device extends Block {
    constructor() {
        super(...arguments);
        this.attributes = [
            new StringAttribute({ name: 'version', defaultValue: '4.2.5.8', isReadOnly: true }),
            new StringAttribute({ name: 'serialNumber', defaultValue: '00000000', isReadOnly: true }),
        ];
        this.className = 'Device';
        this.instanceTag = 'DEVICE';
    }
    handleCommand(socket, args, indices) {
        var _a, _b, _c, _d, _e, _f;
        const cmd = (_a = args[1]) !== null && _a !== void 0 ? _a : '';
        if (cmd === 'startAudio' || cmd === 'stopAudio' || cmd === 'reboot') {
            socket.send(`+OK`);
        }
        else if (cmd === 'recallPreset' || cmd === 'recallPresetByName') {
            const preset = (_b = args[2]) !== null && _b !== void 0 ? _b : '';
            if (preset === undefined) {
                const pos = (_d = (_c = indices === null || indices === void 0 ? void 0 : indices[1]) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : '?';
                socket.send(`-ERR Parse error at ${pos}: not enough parameters supplied`);
                return;
            }
            if (cmd === 'recallPreset' && !Number.isNaN(parseFloat(preset))) {
                const pos = (_f = (_e = indices === null || indices === void 0 ? void 0 : indices[2]) === null || _e === void 0 ? void 0 : _e[0]) !== null && _f !== void 0 ? _f : '?';
                socket.send(`-ERR Parse error at ${pos}: could not parse value`);
                return;
            }
            socket.send(`+OK`);
        }
        else {
            super.handleCommand(socket, args, indices);
        }
    }
}
class Session extends Block {
    constructor(blocks) {
        super();
        this.blocks = blocks;
        this.attributes = [];
        this.className = 'TextSession';
        this.instanceTag = 'SESSION';
        this.attributes.push(new BooleanAttribute({ name: 'verbose' }));
    }
    handleCommand(socket, args, indices) {
        var _a, _b;
        const cmd = (_a = args[1]) !== null && _a !== void 0 ? _a : '';
        const attr = (_b = args[2]) !== null && _b !== void 0 ? _b : '';
        if (cmd === 'get' && attr === 'aliases') {
            const aliases = this.blocks.map(block => `"${block.instanceTag}"`).join(' ');
            socket.send(`+OK "list":[${aliases}]`);
            return;
        }
        else {
            super.handleCommand(socket, args, indices);
        }
    }
}
class LevelControlInterface extends Block {
    constructor(instanceTag, numChannels) {
        super(numChannels);
        this.instanceTag = instanceTag;
        this.attributes = [];
        this.className = 'LevelControlInterface';
        this.attributes.push(new BooleanAttribute({ name: 'mute', numChannels }));
        this.attributes.push(new NumberAttribute({ name: 'level', numChannels, range: { max: 12, min: -100 } }));
        this.attributes.push(new NumberAttribute({
            name: 'maxLevel',
            numChannels,
            defaultValue: 12,
            range: { max: 12, min: -100 },
        }));
        this.attributes.push(new NumberAttribute({
            name: 'minLevel',
            numChannels,
            defaultValue: -100,
            range: { max: 12, min: -100 },
        }));
    }
}
class LogicMeterInterface extends Block {
    constructor(instanceTag, numChannels) {
        super(numChannels);
        this.instanceTag = instanceTag;
        this.attributes = [];
        this.className = 'LogicMeterInterface';
        this.states = new BooleanAttribute({ name: 'state', numChannels });
        this.attributes.push(this.states);
    }
    handleCommand(socket, args, indices) {
        if (args[1] === 'get' && args[2] === 'numChannels') {
            socket.send(`-ERR 'numChannels' is not supported by ${this.className}::Attributes`);
            return;
        }
        else if (args[1] === 'get' && args[2] === 'states') {
            for (let i = 0; i < this.numChannels; i++) {
                if (this.states.values[i] === undefined) {
                    this.states.values[i] = this.states.defaultValue;
                }
            }
            socket.send(`+OK "value":[${this.states.values.join(' ')}]`);
            return;
        }
        super.handleCommand(socket, args, indices);
    }
}
class MuteControlInterface extends Block {
    constructor(instanceTag, numChannels) {
        super(numChannels);
        this.instanceTag = instanceTag;
        this.attributes = [];
        this.className = 'MuteControlInterface';
        this.attributes.push(new BooleanAttribute({ name: 'mute', numChannels }));
    }
}
class RoomCombinerInterface extends Block {
    constructor(instanceTag, numChannels) {
        super(numChannels);
        this.instanceTag = instanceTag;
        this.attributes = [];
        this.className = 'RoomCombinerInterface';
        this.attributes.push(new NumberAttribute({ name: 'levelOut', numChannels, range: { max: 12, min: -100 } }));
    }
    handleCommand(socket, args, indices) {
        if (args[1] === 'get' && args[2] === 'numChannels') {
            socket.send(`-ERR 'numChannels' is not supported by ${this.className}::Attributes`);
            return;
        }
        super.handleCommand(socket, args, indices);
    }
}
class VoipControlStatusInterface extends Block {
    constructor(instanceTag, numChannels, timeouts) {
        super(numChannels);
        this.instanceTag = instanceTag;
        this.timeouts = timeouts;
        this.attributes = [];
        this.className = 'VoIPControlStatusInterface';
        this.numCallAppearances = 6;
        this.callState = new StringAttribute({
            name: 'callState',
            isReadOnly: true,
            addQuotes: false,
            defaultValue: this.makeCallState('VOIP_CALL_STATE_IDLE'),
        });
        this.attributes.push(this.callState);
    }
    handleCommand(socket, args, indices) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const cmd = args[1];
        const line = args[2];
        const callAppearance = args[3];
        if (cmd === 'answer' || cmd === 'end' || cmd === 'dtmf' || cmd === 'dial') {
            if (line === undefined || callAppearance === undefined) {
                const pos = (_f = (_d = (_b = (_a = indices === null || indices === void 0 ? void 0 : indices[3]) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : (_c = indices === null || indices === void 0 ? void 0 : indices[2]) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : (_e = indices === null || indices === void 0 ? void 0 : indices[1]) === null || _e === void 0 ? void 0 : _e[1]) !== null && _f !== void 0 ? _f : '?';
                let msg = `-ERR Parse error at ${pos}: `;
                msg += `not enough parameters supplied`;
                socket.send(msg);
                return;
            }
            const lineIndex = parseIndex(2, args, indices, this.numChannels);
            if (lineIndex instanceof ErrorMessage) {
                socket.send(lineIndex.message);
                return;
            }
            if (cmd !== 'dtmf') {
                const callAppearanceIndex = parseIndex(2, args, indices, this.numCallAppearances);
                if (callAppearanceIndex instanceof ErrorMessage) {
                    socket.send(callAppearanceIndex.message);
                    return;
                }
            }
            if (cmd === 'answer') {
                this.callState.set(socket, this.makeCallState('VOIP_CALL_STATE_ACTIVE', 'Unknown Caller'));
                socket.send(`+OK`);
            }
            else if (cmd === 'dtmf') {
                const value = args[3];
                if (value === undefined) {
                    const pos = (_h = (_g = indices === null || indices === void 0 ? void 0 : indices[2]) === null || _g === void 0 ? void 0 : _g[1]) !== null && _h !== void 0 ? _h : '?';
                    let msg = `-ERR Parse error at ${pos}: `;
                    msg += `not enough parameters supplied`;
                    socket.send(msg);
                    return;
                }
                socket.send(`+OK`);
            }
            else if (cmd === 'dial') {
                const value = (_j = args[4]) !== null && _j !== void 0 ? _j : '';
                if (value === undefined) {
                    const pos = (_l = (_k = indices === null || indices === void 0 ? void 0 : indices[3]) === null || _k === void 0 ? void 0 : _k[1]) !== null && _l !== void 0 ? _l : '?';
                    let msg = `-ERR Parse error at ${pos}: `;
                    msg += `not enough parameters supplied`;
                    socket.send(msg);
                    return;
                }
                socket.send(`+OK`);
                this.timeouts.set(() => {
                    this.callState.set(socket, this.makeCallState('VOIP_CALL_STATE_DIALING'));
                }, 100);
                this.timeouts.set(() => {
                    if (/VOIP_CALL_STATE_DIALING/.exec(this.callState.get())) {
                        this.callState.set(socket, this.makeCallState('VOIP_CALL_STATE_ACTIVE', value));
                    }
                }, 1000);
            }
            else if (cmd === 'end') {
                socket.send(`+OK`);
                this.callState.set(socket, this.makeCallState('VOIP_CALL_STATE_IDLE'));
            }
        }
        else {
            super.handleCommand(socket, args, indices);
        }
    }
    makeCallState(value, cid) {
        const lineStates = [];
        const idle = 'VOIP_CALL_STATE_IDLE';
        for (let line = 0; line < this.numChannels; line++) {
            for (let cap = 0; cap < this.numCallAppearances; cap++) {
                const capStates = [];
                capStates.push(`"state":${line === 0 && cap === 0 ? value : idle}`);
                capStates.push(`"lineId":${line}`);
                capStates.push(`"callId":${cap}`);
                capStates.push(`"action":UI_DISPLAY_STATUS`);
                capStates.push(`"cid":"${line === 0 && cid !== undefined ? cid : ''}"`);
                capStates.push(`"prompt":VOIP_PROMPT_NONE`);
                lineStates.push(`{${capStates.join(' ')}}`);
            }
        }
        return `{"callStateInfo":[${lineStates.join(' ')}]}`;
    }
}
export class Tesira {
    constructor(socket, log) {
        this.socket = socket;
        this.blocks = [];
        this.timeouts = new Timeouts();
        this.asyncHandlers = [
            {
                match: (str) => str,
                callback: (str) => {
                    const [args, indices] = tokenize(str);
                    for (const block of this.blocks) {
                        if (block.instanceTag === args[0]) {
                            block.handleCommand(this.socket, args, indices);
                            return;
                        }
                    }
                    let msg = `-ERR address not found: `;
                    msg += `{"deviceId": 0 "classCode":0 "instanceNum":0 }`;
                    this.socket.send(msg);
                },
            },
        ];
        this.blocks.push(new Session(this.blocks));
        this.blocks.push(new Device());
        this.blocks.push(new LevelControlInterface('Amplifier', 1));
        this.blocks.push(new LevelControlInterface('Assistive Listening', 1));
        this.blocks.push(new MuteControlInterface('Mics', 1));
        this.blocks.push(new LevelControlInterface('Overflow Room A', 1));
        this.blocks.push(new LevelControlInterface('Overflow Room B', 1));
        this.blocks.push(new LevelControlInterface('Overflow Room C', 1));
        this.blocks.push(new LevelControlInterface('Overflow Room D', 1));
        this.blocks.push(new LevelControlInterface('Overflow Room E', 1));
        this.blocks.push(new LevelControlInterface('Overflow Room F', 1));
        this.blocks.push(new LevelControlInterface('Overflow Room G', 1));
        this.blocks.push(new VoipControlStatusInterface('VoIP Control Status', 2, this.timeouts));
        this.blocks.push(new LevelControlInterface('VoIP Receive Gain', 1));
        this.blocks.push(new LevelControlInterface('Audio Input A', 1));
        this.blocks.push(new LevelControlInterface('Audio Input B', 1));
        this.blocks.push(new LevelControlInterface('Audio Input C', 1));
        this.blocks.push(new LevelControlInterface('Audio Input D', 1));
        this.blocks.push(new LevelControlInterface('Audio Input E', 1));
        this.blocks.push(new LevelControlInterface('Audio Input F', 1));
        this.blocks.push(new LevelControlInterface('Audio Input G', 1));
        this.blocks.push(new LevelControlInterface('Sound Reinforcement', 4));
        this.blocks.push(new LogicMeterInterface('Logic Meter', 4));
        this.blocks.push(new RoomCombinerInterface('RoomCombiner1', 20));
        this.blocks.push(new RoomCombinerInterface('RoomCombiner2', 20));
    }
    //public readonly commandExtractor: CommandExtractor = {
    //    terminators: ['\r', '\n'],
    //};
    //public readonly sendTerminator = '\r\n';
    onDisconnect() {
        this.timeouts.clearAll();
    }
    onInitialize() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.timeouts.delay(500);
            this.socket.send(`Welcome to the Tesira Text Protocol Server...`);
            this.socket.send(``);
        });
    }
}
Tesira.emulatorType = 'socketEmulator';
Tesira.key = '-KVMNDN3teZc3mpr3I3z';
